import { AutoMap } from "@automapper/classes"
import { EPortee } from "./enums/portee"
import { Prelevement } from "../prelevement"
import { BaseDOM } from "../base.dom"

export class Canal extends BaseDOM<Canal> {
    @AutoMap()
    Portee: EPortee = EPortee.CanalAirEau
    @AutoMap()
    VolumeLiquideInjecte: number = 0

    @AutoMap()
    Prelevement: Prelevement = new Prelevement()
}